<script>
  import { onMount } from "svelte";
  import { page } from "$app/stores";
  import { logout } from "/util";
  import fetch from "/util";
  import {
    Menu,
    X,
    User,
    Settings,
    Archive,
    Printer,
    TrendingUp,
    Wrench,
    FileText,
    LogOut,
    ChevronDown,
  } from 'lucide-svelte';

  let user = JSON.parse(localStorage.getItem("user"));
  let workspaceStatus = "active";
  let showMenu = false;

  // 아코디언 상태 관리
  let expandedSections = {
    basicInfo: false,
    asset: false,
    monitoring: false,
    monitoringData: false,
    as: false,
    contract: false,
  };

  onMount(async () => {
    try {
      const response = await fetch(`/workspaces/${user.WorkspaceID}`);
      if (response.ok) {
        const workspace = await response.json();
        workspaceStatus = workspace.Status;
      }
    } catch (error) {
      console.error("Error loading workspace:", error);
    }
  });

  // 현재 활성 경로 확인
  $: currentPath = $page.url.pathname;

  function toggleMenu() {
    showMenu = !showMenu;
  }

  function closeMenu() {
    showMenu = false;
  }

  function toggleSection(section) {
    const isCurrentlyExpanded = expandedSections[section];

    // 모든 섹션 닫기
    Object.keys(expandedSections).forEach((key) => {
      expandedSections[key] = false;
    });

    // 클릭한 섹션이 닫혀있었다면 열기
    if (!isCurrentlyExpanded) {
      expandedSections[section] = true;
    }
  }

  function handleLogout() {
    closeMenu();
    logout();
  }
</script>

<!-- 상단 헤더 -->
<header
  class="gnb-mobile sticky top-0 bg-white z-[100] p-4 shadow-md flex items-center justify-end"
>
  <div style="flex: 1; text-align: left;">
    <a
      id="gnb-logo"
      href="/mobile/partner/as/today"

      class="cursor-pointer"
    >
      <img alt="CMYK" class="h-8" src="/assets/images/gnb_logo.png" />
    </a>
  </div>
  <div>
    <a
      href="/mobile/partner/as/register"

      class="px-4 py-2 rounded-lg text-white font-medium text-sm bg-gray-800 mr-4"
    >
      A/S접수
    </a>
    <button
      id="btn-open-mobile-menu"
      aria-label="메뉴 열기"
      aria-expanded={showMenu}
      aria-controls="mobile-menu"
      class="bg-transparent border-none cursor-pointer p-2 w-12"
      style="color: var(--gray-700);"
      on:click={toggleMenu}
    >
      <Menu size={20} />
    </button>
  </div>
</header>

<!-- 사이드 메뉴 오버레이 -->
{#if showMenu}
  <div
    class="mobile-menu-backdrop"
    role="button"
    tabindex="-1"
    aria-label="메뉴 닫기"
    on:click={closeMenu}
    on:keydown={(e) => { if (e.key === 'Escape') closeMenu(); }}
  ></div>

  <div id="mobile-menu" class="side-menu-container" role="navigation" aria-label="모바일 메뉴">
    <div class="side-menu-header">
      <button
        id="btn-close-mobile-menu"
        aria-label="메뉴 닫기"
        class="p-2 text-xl bg-transparent border-none cursor-pointer"
        style="color: var(--gray-700);"
        on:click={closeMenu}
      >
        <X />
      </button>
    </div>

    <div id="mobile-menu-content" class="side-menu-content">
      <!-- 내 정보 -->
      <div class="menu-section">
        <a
          href="/mobile/partner/myinfo"
          class="menu-button"
          on:click={closeMenu}
        >
          <User class="menu-icon" />
          <span class="flex-1">내 정보</span>
        </a>
      </div>

      {#if workspaceStatus === "active"}
        <!-- 기초 정보 -->
        <div class="menu-section">
          <button
            class="menu-button"
            on:click={() => toggleSection("basicInfo")}
          >
            <Settings class="menu-icon" />
            <span class="flex-1">기초 정보</span>
            <span class="mobile-menu-chevron" class:mobile-menu-chevron-open={expandedSections.basicInfo}>
              <ChevronDown size={16} />
            </span>
          </button>
          {#if expandedSections.basicInfo}
            <div class="submenu-container">
              <!-- {#if user.Type === "owner"}
                <a href="/mobile/partner/operation/company" class="submenu-item"  on:click={closeMenu}>
                  관리 사업자
                </a>
                <a href="/mobile/partner/members" class="submenu-item"  on:click={closeMenu}>
                  구성원
                </a>
                <a href="/mobile/partner/operation/warehouse" class="submenu-item"  on:click={closeMenu}>
                  창고
                </a>
                <a href="/mobile/partner/operation/equipment-model" class="submenu-item"  on:click={closeMenu}>
                  장비 모델
                </a>
              {/if}
              <a href="/mobile/partner/operation/consumables" class="submenu-item"  on:click={closeMenu}>
                부소모품 코드
              </a> -->
              <a
                href="/mobile/partner/customer"
                class="submenu-item submenu-item-last"

                on:click={closeMenu}
              >
                고객
              </a>
            </div>
          {/if}
        </div>

        <!-- 자산 -->
        <div class="menu-section">
          <button class="menu-button" on:click={() => toggleSection("asset")}>
            <Archive class="menu-icon" />
            <span class="flex-1">자산</span>
            <span class="mobile-menu-chevron" class:mobile-menu-chevron-open={expandedSections.asset}>
              <ChevronDown size={16} />
            </span>
          </button>
          {#if expandedSections.asset}
            <div class="submenu-container">
              <a
                href="/mobile/partner/resource/equipment"
                class="submenu-item"

                on:click={closeMenu}
              >
                복합기·프린터 현황
              </a>
              <!-- <a href="/mobile/partner/resource/consumables" class="submenu-item"  on:click={closeMenu}>
                부소모품 입출고
              </a> -->
              <a
                href="/mobile/partner/resource/consumable-inventory"
                class="submenu-item submenu-item-last"

                on:click={closeMenu}
              >
                부소모품 재고
              </a>
            </div>
          {/if}
        </div>

        <!-- 장비 관리 -->
        <div class="menu-section">
          <button
            class="menu-button"
            on:click={() => toggleSection("monitoring")}
          >
            <Printer class="menu-icon" />
            <span class="flex-1">장비 관리</span>
            <span class="mobile-menu-chevron" class:mobile-menu-chevron-open={expandedSections.monitoring}>
              <ChevronDown size={16} />
            </span>
          </button>
          {#if expandedSections.monitoring}
            <div class="submenu-container">
              <a
                href="/mobile/partner/printer"
                class="submenu-item"

                on:click={closeMenu}
              >
                복합기·프린터 관리
              </a>
              <!-- <a href="/mobile/partner/printer/unregistered" class="submenu-item submenu-item-last"  on:click={closeMenu}>
                메일수집장비 등록
              </a> -->
            </div>
          {/if}
        </div>

        <!-- 모니터링 -->
        <div class="menu-section">
          <button
            class="menu-button"
            on:click={() => toggleSection("monitoringData")}
          >
            <TrendingUp class="menu-icon" />
            <span class="flex-1">모니터링</span>
            <span class="mobile-menu-chevron" class:mobile-menu-chevron-open={expandedSections.monitoringData}>
              <ChevronDown size={16} />
            </span>
          </button>
          {#if expandedSections.monitoringData}
            <div class="submenu-container">
              <a
                href="/mobile/partner/monitoring/data/usage"
                class="submenu-item"

                on:click={closeMenu}
              >
                사용량
              </a>
              <a
                href="/mobile/partner/monitoring/data/supplies"
                class="submenu-item"

                on:click={closeMenu}
              >
                소모품
              </a>
              <a
                href="/mobile/partner/monitoring/customer"
                class="submenu-item submenu-item-last"

                on:click={closeMenu}
              >
                고객현황
              </a>
            </div>
          {/if}
        </div>

        <!-- A/S -->
        <div class="menu-section">
          <button class="menu-button" on:click={() => toggleSection("as")}>
            <Wrench class="menu-icon" />
            <span class="flex-1">A/S</span>
            <span class="mobile-menu-chevron" class:mobile-menu-chevron-open={expandedSections.as}>
              <ChevronDown size={16} />
            </span>
          </button>
          {#if expandedSections.as}
            <div class="submenu-container">
              <a
                href="/mobile/partner/as/today"
                class="submenu-item"

                on:click={closeMenu}
              >
                오늘의 A/S
              </a>
              <a
                href="/mobile/partner/as/register"
                class="submenu-item"

                on:click={closeMenu}
              >
                접수
              </a>
              <a
                href="/mobile/partner/as/progress"
                class="submenu-item"

                on:click={closeMenu}
              >
                진행
              </a>
              <a
                href="/mobile/partner/as/completed"
                class="submenu-item submenu-item-last"

                on:click={closeMenu}
              >
                완료
              </a>
              <!-- <a href="/mobile/partner/as/consumable-usages" class="submenu-item submenu-item-last"  on:click={closeMenu}>
                부소모품 사용 현황
              </a> -->
            </div>
          {/if}
        </div>

        <!-- 계약 -->
        <!-- <div class="menu-section">
          <button class="menu-button" on:click={() => toggleSection('contract')}>
            <i class="fas fa-file-contract menu-icon"></i>
            <span class="flex-1">계약</span>
            <i class="chevron" class:rotate-180={expandedSections.contract}></i>
          </button>
          {#if expandedSections.contract}
            <div class="submenu-container">
              <a href="/mobile/partner/contractable/printer" class="submenu-item"  on:click={closeMenu}>
                미계약 장비
              </a>
              <a href="/mobile/partner/contract" class="submenu-item"  on:click={closeMenu}>
                계약 목록
              </a>
              <a href="/mobile/partner/contract/invoice" class="submenu-item"  on:click={closeMenu}>
                계약 명세서 발행
              </a>
              <a href="/mobile/partner/contract/invoice/issued" class="submenu-item submenu-item-last"  on:click={closeMenu}>
                계약 명세서 완료
              </a>
            </div>
          {/if}
        </div> -->
      {/if}

      <div class="menu-section">
        <button class="menu-button" on:click={handleLogout}>
          <LogOut class="menu-icon" />
          <span class="flex-1">로그아웃</span>
        </button>
      </div>
    </div>
  </div>
{/if}

<style>
  /* 데스크톱 CSS를 로드한 뒤 화면을 줄여도 메뉴 배치와 닫기가 유지돼야 한다. */
  .mobile-menu-backdrop {
    position: fixed;
    inset: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .side-menu-container {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    width: 280px;
    max-width: 100vw;
    background: white;
    z-index: 1000;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.15);
    animation: slideIn 0.3s ease-out;
    display: flex;
    flex-direction: column;
  }

  .side-menu-header {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 1rem;
    min-height: 60px;
    box-sizing: border-box;
    flex-shrink: 0;
  }

  .side-menu-content {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
  }

  .menu-button,
  #btn-close-mobile-menu {
    min-height: 44px;
  }

  @keyframes slideIn {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  /* 메뉴 섹션 */
  .menu-section {
    flex-shrink: 0;
    border-bottom: 1px solid var(--gray-300);
  }

  /* 메뉴 버튼 공통 스타일 */
  .menu-button {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 1.5rem;
    background: white;
    border: none;
    cursor: pointer;
    font-size: 0.95rem;
    width: 100%;
    text-align: left;
    position: relative;
    flex-shrink: 0;
    color: var(--gray-700);
    text-decoration: none;
  }

  /* 쉐브론 아이콘 */
  .mobile-menu-chevron {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    transition: transform 0.3s;
    color: var(--gray-500);
  }

  .mobile-menu-chevron-open {
    transform: rotate(180deg);
  }

  /* 서브메뉴 컨테이너 */
  .submenu-container {
    background: white;
  }

  /* 서브메뉴 아이템 */
  .submenu-item {
    display: block;
    padding: 0.875rem 1.5rem;
    padding-left: 3.5rem;
    text-decoration: none;
    font-size: 0.9rem;
    flex-shrink: 0;
    color: var(--gray-700);
    border-bottom: 1px solid var(--gray-200);
  }

  /* 마지막 서브메뉴 아이템 */
  .submenu-item-last {
    border-bottom: none !important;
  }

  /* 버튼 스타일 초기화 */
  button {
    outline: none;
    font-family: inherit;
  }

  button:focus {
    outline: none;
  }

  /* 호버 효과 */
  .menu-button:active,
  .submenu-item:active {
    background-color: var(--gray-100) !important;
  }
</style>
